import { type FunctionComponent } from 'react';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const SelectItemContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <VerticalContainer className={`${className} ${styles.selectItemContainer}`} testId={testId}>
        {children}
    </VerticalContainer>
);

export default SelectItemContainer;
